
import { HttpErrorResponse, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { inject, InjectionToken, NgModule } from '@angular/core';
import { ApolloClientOptions, ApolloLink, DefaultOptions, InMemoryCache } from '@apollo/client/core';
import { onError } from '@apollo/client/link/error';
import { APOLLO_OPTIONS, provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { MessageService } from 'primeng/api';


const defaultOptionsParams: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
};


export function createApollo(httpLink: HttpLink, token: string, messageService: MessageService, environment: any): ApolloClientOptions<any> {
  const uri = environment.apiURL + "/graphql";
  return {
    link: ApolloLink.from([
      onError(({ graphQLErrors, networkError }) => {
        if (graphQLErrors) {
          graphQLErrors.map(({ message, locations, path }) =>
            messageService.add({ severity: 'error', detail: message, life: 5000 })
          );
        }

        if (networkError) {
          const error = networkError as HttpErrorResponse;
          if (error.status == 401) {
            const event = new CustomEvent('auth-error', { detail: error });
            window.dispatchEvent(event);
          }
          console.log(`[Network error]: ${networkError}`);
        }
      }),
      httpLink.create({ uri, withCredentials: false })
    ]),
    cache: new InMemoryCache({ addTypename: false }),
    headers: {
      authorization: `Bearer ${token}`
    },
    defaultOptions: defaultOptionsParams
  };
}

@NgModule({
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideApollo(() => {
      const httpLink = inject(HttpLink);
      const jwt = inject(new InjectionToken<string>('JWT'));
      const messageService = inject(MessageService);
      const environment = inject(new InjectionToken<string>('environment'));
      return createApollo(httpLink,jwt,messageService,environment);
    }),
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink, 'jwt', MessageService, 'environment'],
    }
  ],
})
export class GraphQLModule {
}
